import * as React from 'react';

import { Binding } from 'core/infrastructure';
import { cloneExcept, Currency, Environment } from 'core/utils';

import { FormComponent } from './Form';
import { Constraint } from './Constraints';
import { DecimalBox, DecimalBoxCtor } from './DecimalBox';
import * as Format from './Format';


interface Props<T> extends React.DetailedHTMLProps<React.InputHTMLAttributes<PriceBox<T>>, PriceBox<T>> {
	linkTo: Binding.PropertyPath<T>;
	label?: string | React.ReactNode;
	rules?: Constraint | Constraint[];
	onEnterPress?: () => void;
	onValueChange?: (value: string) => void;
	boundValue?: any;
	allowNegative?: boolean;
	syncTextFrom?: string;
	childrenPosition?: 'append' | 'prepend'
}

export class PriceBox<T> extends React.Component<Props<T>, EmptyState> implements FormComponent {

	private textBox = React.createRef<DecimalBox<T>>();

	constructor(props: Props<T>) {
		super(props);
	}

	getPath() {
		return this.textBox.current!.getPath();
	}

	showErrors(errors: string[]) {
		this.textBox.current!.showErrors(errors);
	}

	setValue(value: number) {
		this.textBox.current!.setValue(value);
	}

	getValue() {
		return this.textBox.current!.getValue();
	}

	activate() {
		this.textBox.current!.activate();
	}

	render() {
		const TheTextBox: DecimalBoxCtor<T> = DecimalBox;

		const props = cloneExcept(this.props, ['ref']);
		props.precision = Currency.DECIMAL_PLACES;
		props.format = Format.asPriceNoGrouping;

		// En Safari sobre iOS se producen fallos a la hora
		// de escribir en inputs formateados con decimales.
		// Para evitar estos fallos se usa este hack sacado de
		// https://github.com/reactjs/react-modal/issues/233#issuecomment-250532918
		if (Environment.isiOS())
			props.style = { transform: 'translate3d(0px, 0px, 0px)' };

		return <TheTextBox ref={this.textBox} {...props} />;
	}
}

export type PriceBoxCtor<T> = new (props: Props<T>) => PriceBox<T>;
